module.exports = __webpack_public_path__ + "static/media/icon-remetente.a202fefe.svg";